import { LogOut } from 'lucide-react'
import type { ReactNode } from 'react'
import { EVENT } from '@sdg/shared'

export function PortalHeader({
  portal,
  identity,
  details,
  rightContent,
  onSignOut,
}: {
  portal: string
  identity: string
  details: string
  rightContent?: ReactNode
  onSignOut: () => void
}) {
  return (
    <header className="relative flex min-h-[72px] shrink-0 items-center justify-between gap-3 border-b border-white/80 bg-white/75 px-3 shadow-[0_8px_28px_rgba(30,64,110,0.07)] backdrop-blur-xl sm:px-6">
      <div
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[#1E4F91]/55 via-[#38A9D6]/40 to-[#E6A23C]/45"
        aria-hidden
      />
      <div className="flex min-w-0 flex-1 items-center">
        <div className="min-w-0">
          <p className="truncate text-[9px] font-semibold uppercase tracking-[0.11em] text-[#526B86] sm:text-[10px]">
            Lincoln University College Malaysia
            <span className="px-1.5 text-[#B88A45]">/</span>
            {portal}
          </p>
          <h1 className="truncate text-[15px] font-semibold leading-5 text-[#102B4C] sm:text-[17px]">
            SDG &amp; Cultural Day 2026
          </h1>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2 sm:gap-4">
        <div className="hidden min-w-0 text-right sm:block">
          <p className="max-w-48 truncate text-xs font-semibold text-[#102B4C]">{identity}</p>
          <p className="text-[11px] text-slate-500">{details}</p>
        </div>
        {rightContent}
        <button
          type="button"
          onClick={onSignOut}
          className="inline-flex h-9 shrink-0 items-center gap-1.5 rounded-md border border-transparent bg-transparent px-2.5 text-xs font-semibold text-[#526B86] transition-colors hover:border-white/80 hover:bg-white/70 hover:text-[#173B66] sm:px-3"
        >
          <LogOut className="size-3.5" strokeWidth={2} />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  )
}

export function PortalFooter() {
  return (
    <footer className="relative flex min-h-12 shrink-0 flex-col items-center justify-between gap-1 overflow-hidden border-t border-white/80 bg-white/70 px-4 py-2 text-center text-[11px] text-slate-500 shadow-[0_-8px_24px_rgba(30,64,110,0.04)] backdrop-blur-xl sm:flex-row sm:px-6 sm:text-left">
      <div
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-[#1E4F91]/35 via-[#38A9D6]/45 to-[#E6A23C]/40"
        aria-hidden
      />
      <span className="font-medium text-[#526B86]">{EVENT.name}</span>
      <span>
        Technology partner{' '}
        <a
          href={EVENT.technologyPartnerUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="font-semibold text-[#173B66] underline decoration-[#9AB2C9] underline-offset-2 hover:decoration-current"
        >
          {EVENT.technologyPartner}
        </a>
      </span>
    </footer>
  )
}
